import { MDBDataTable } from "mdbreact"
import React, { useEffect, useRef, useState } from "react"
import MetaTags from "react-meta-tags"
import { Col, Container, Row, Alert } from "reactstrap"
import { Link } from "react-router-dom"

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"

// services
import Admin from "../../services/admin/Admin"

const adminService = new Admin()

const ConsumptionItems = props => {
  const [items, setItems] = useState([])
  const [modal, setModal] = useState(false)
  const [newItemName, setNewItemName] = useState("")
  const [areaName, setAreaName] = useState("")
  const [areaId, setAreaId] = useState(props.location.search.split("=")[1])

  useEffect(() => {
    fetchConsumptionAreaInfo(areaId)
    fetchConsumptionItems(areaId)
  }, [])

  const toggleModal = () => {
    setModal(!modal)
  }

  const fetchConsumptionAreaInfo = async id => {
    try {
      const response = await adminService.getConsumptionArea(id)
      if (response.code == 200) {
        setAreaName(response.data.name)
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const fetchConsumptionItems = async id => {
    try {
      const response = await adminService.getConsumptionAreaItems(id)
      setItems(response.data)
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const addConsumptionItem = async () => {
    if (newItemName == "") {
      alert("Item name cannot be empty!")
      return
    }

    try {
      const response = await adminService.addConsumptionAreaItem(
        areaId,
        newItemName
      )
      if (response.code == 200) {
        setNewItemName("")
        toggleModal()
        fetchConsumptionItems(areaId)
      } else {
        alert("Error adding item!")
      }
    } catch (error) {
      console.error("Error adding consumption area:", error)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Consumption Area Items</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">Consumption Items for {areaName}</div>
          <Row>
            <div>
              <Row>
                <Col md={8}>
                  Consumption Area Name: <b>{areaName}</b>
                </Col>

                <Col md={4}>
                  <Button color="primary" onClick={toggleModal}>
                    Add New {" " + areaName + " "} Consumption Item
                  </Button>
                </Col>
              </Row>

              <Modal isOpen={modal} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>
                  Add New Consumption Item for {areaName}
                </ModalHeader>
                <ModalBody>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter the name of the new consumption area"
                    value={newItemName}
                    onChange={e => setNewItemName(e.target.value)}
                  />
                </ModalBody>
                <ModalFooter>
                  <Button color="primary" onClick={addConsumptionItem}>
                    Add
                  </Button>{" "}
                  <Button color="secondary" onClick={toggleModal}>
                    Cancel
                  </Button>
                </ModalFooter>
              </Modal>

              <table className="table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((area, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{area.name}</td>
                      <td>{new Date(area.created_at).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ConsumptionItems
